import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import { IInstructionQuestionModelState, IInstructionResponseValidation, InstructionQuestionModelTypes } from './types'

const InstructionQuestionModel: IQuestionModelConstructor<InstructionQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<InstructionQuestionModelTypes, IInstructionQuestionModelState>({
    questionType: QuestionType.INSTRUCTION,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IInstructionQuestionModelState) {
  return response
}

function initState(state: IInstructionQuestionModelState): IInstructionQuestionModelState {
  state.response = [{ id: state.questionSchema.id }]
  return state
}

function validateResponse(): IInstructionResponseValidation {
  return {
    valid: true
  }
}

export default InstructionQuestionModel
